// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"234":"27c8bdeb","384":"89c9b37b","821":"f55fb93d","910":"23c64dcb"}[chunkId] + ".css?version=0.1.0";
};